//

import React, { Component } from 'react';
import Bulkoperation from './bulkoperation';

/**
 *  置换 skn
 */
export class BulkOperation extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Bulkoperation rows={row} entity={entity} />
            </div>
        );
    }
}
